import client from "../config/axios";

export const updateDraftWithRanking = async (data) => {
  const response = await client.post("/super-power-draft/update-with-ranking",{ ...data });
  return response.data;
};
